export default __webpack_public_path__ + "locales/en/DataReassignmentDialog.json?hash=ff69f9468c825d0566a69d2fa6633e77";